import { useEffect } from "react";

type prop = {
  type: string;
  setPage: (num: number) => void;
  onTypeChange?: (type: string) => void;
};

const RadioSearchNav = ({ type, setPage, onTypeChange }: prop) => {
  // Add custom CSS for active state
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .radio-nav-active {
        border-bottom: 3px solid #47BBA9 !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div
      className="btn-group"
      role="group"
      aria-label="Basic radio toggle button group"
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedType = e.target.value;
        setPage(1);
        onTypeChange?.(selectedType);
        // Keep URL consistent, don't navigate
      }}
    >
      <input
        type="radio"
        className="btn-check "
        defaultValue="shortlet"
        name="btnradio"
        id="btnradio1"
        autoComplete="off"
        checked={type === "shortlet"}
        readOnly
      />
      <label
        className={`btn btn-tab-button px-3 px-md-5 py-3 rounded-bottom-left-0 bg-transparent border-0 ${
          type === "shortlet" ? "text-primary fw-500 radio-nav-active" : ""
        }`}
        htmlFor="btnradio1"
      >
        Shortlet
      </label>

      <input
        type="radio"
        className="btn-check"
        defaultValue="rent"
        name="btnradio"
        id="btnradio2"
        autoComplete="off"
        checked={type === "rent" || type === "long lease"}
        readOnly
      />
      <label
        className={`btn btn-tab-button px-3 px-md-5 py-3 bg-transparent border-0 ${
          type === "rent" || type === "long lease"
            ? "text-primary fw-500 radio-nav-active"
            : ""
        }`}
        htmlFor="btnradio2"
      >
        Rent
      </label>

      {/* For Sale is temporarily unavailable.
      <input
        type="radio"
        className="btn-check"
        defaultValue="sale"
        name="btnradio"
        id="btnradio3"
        autoComplete="off"
        checked={type === "sale"}
        readOnly
      />
      <label
        className={`btn btn-tab-button px-3 px-md-5 py-3 rounded-bottom-right-0 bg-transparent border-0 ${
          type === "sale" ? "text-primary fw-500 radio-nav-active" : ""
        }`}
        htmlFor="btnradio3"
      >
        For Sale
      </label>
      */}
    </div>
  );
};
export default RadioSearchNav;
